async function clearAppCache() {
  if (!("caches" in window)) return;

  const cacheKeys = await caches.keys();
  await Promise.all(cacheKeys.map((cacheName) => caches.delete(cacheName)));
}

async function unregisterExistingServiceWorkers() {
  if (!("serviceWorker" in navigator)) return;

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(
    registrations.map(async (registration) => {
      try {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: "SKIP_WAITING" });
        }
        await registration.unregister();
      } catch (error) {
        console.error("Error al desregistrar service worker", error);
      }
    })
  );
}

export function register() {
  // Mantener una experiencia estable evita que bundles viejos queden vivos en PWA.
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    try {
      await unregisterExistingServiceWorkers();
      await clearAppCache();
    } catch (error) {
      console.error("Error limpiando service workers/cache", error);
    }
  });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then(async (registration) => {
        await registration.unregister();
        await clearAppCache();
      })
      .catch((error) => {
        console.error("Error durante la desactivacion del service worker", error);
      });
  }
}
